// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/giveaway.less
// module id = 410
// module chunks = 0